import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lifeline_donation_modal = _resolveComponent("lifeline-donation-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _withModifiers($setup.onClick, ["prevent"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    ($setup.showModal)
      ? (_openBlock(), _createBlock(_component_lifeline_donation_modal, {
          key: 0,
          onClose: $setup.onClose,
          showModal: $setup.showModal,
          id: $setup.props.id,
          dstyle: $setup.props.dstyle
        }, null, 8 /* PROPS */, ["showModal", "id", "dstyle"]))
      : _createCommentVNode("v-if", true)
  ]))
}